export const MOBILE_AUTH_DEEPLINK = 'fabric-tjxoF7KKC7';
